export class BatchUpload {
    Name: string = "";
    ProjectId: string = "";
    File: any = null;
    FileType: string = "";
    ByteChunkSize: number = 2048000;
    CurrentUploadToken: string = null;
    Uploaded: number = 0;
    ProgressPercent: string = "0%";
    TotalSize: number = 0;
    TotalSizeDetails: any = null;
    ReadableUploaded: string = "";
    ReadableTotalSize: string = "";
    TotalUploadCounts: number = 0;
    CurrentUploadCount: number = 0;
    CompressFile: boolean = false;
    Complete: boolean = false;
}